<template>
    <SiteSection sectionId="section-why-us"
                 sectionNo="1"
                 label="關於新芽實習計畫"
                 title="WHY US?">

        <div class="content-container">
            <ContentBlock isBlank="true"></ContentBlock>
            <ContentBlock labelName="Reason"
                          labelNo="01"
                          v-bind:illustration="images.why01"
                          enTitle="Work with creative people"
                          cnTitle="一起創造分享新事物"
                          contentText="創意發想與設計需要跳脫現狀，我們從不吝嗇分享突然冒出來的新點子，並相信透過整個團隊可以激盪更多靈感並做出不一樣的事情。">
            </ContentBlock>
            <ContentBlock labelName="Reason"
                          labelNo="02"
                          v-bind:illustration="images.why02"
                          enTitle="We shape company culture together"
                          cnTitle="共同塑造公司文化"
                          contentText="我們歡迎各種垃圾話或天馬行空的想法，也樂於接受不同角度的思維與作法，新芽每一份子都會一起形塑並傳播公司文化。">
            </ContentBlock>
            <ContentBlock labelName="Reason"
                          labelNo="03"
                          v-bind:illustration="images.why03"
                          enTitle="Take initiatives in projects"
                          cnTitle="主導專案進行的機會"
                          contentText="新芽的團隊組織架構非常扁平，我們每個人都有機會參與並主導專案或計畫的進行，把不同的構想連結並有效率的執行。">
            </ContentBlock>
            <ContentBlock labelName="Reason"
                          labelNo="04"
                          v-bind:illustration="images.why04"
                          enTitle="Promotion opportunities"
                          cnTitle="升遷為正職夥伴的機會"
                          contentText="實習期間表現優異，我們會非常誠摯並熱烈歡迎您成為我們的正職夥伴，進一步的在未來與我們一起成長並茁壯。">
            </ContentBlock>
            <ContentBlock labelName="Reason"
                          labelNo="05"
                          v-bind:illustration="images.why05"
                          enTitle="Build your own record"
                          cnTitle="累積實戰經驗"
                          contentText="這裡你將有機會接觸各領域的領導品牌客戶，參與可能超過上萬人使用的產品專案，在短時間內累積豐富的實戰經驗。">
            </ContentBlock>
        </div>
    </SiteSection>
</template>

<script>
import SiteSection from "./source/Section.vue";
import ContentBlock from "./source/ContentBlock.vue";

import why01 from '../static/images/sectionWhyUs/why01.png';
import why02 from '../static/images/sectionWhyUs/why02.png';
import why03 from '../static/images/sectionWhyUs/why03.png';
import why04 from '../static/images/sectionWhyUs/why04.png';
import why05 from '../static/images/sectionWhyUs/why05.png';

export default {
    name: 'SectionWhyUs',
    components: {
        SiteSection,
        ContentBlock
    },
    data: () => {
        return {
            images: {
                why01: why01,
                why02: why02,
                why03: why03,
                why04: why04,
                why05: why05
            }
        };
    }
}
</script>

<style scoped
       lang="scss">
    @import "../static/styles/palette.scss";

    .content-container {
        display: flex;
        position: relative;
        flex-wrap: wrap;
        justify-content: center;
        margin: -180px auto 0;
        width: 1024px;
    }

    @media all and (max-width: 1200px) {
        .content-container {
            width: auto;

            & .content-block {
                width: 40%;
            }

        }
    }

    @media all and (max-width: 960px) {
        .content-container {
            margin: -80px auto 0;
        }
    }

    @media all and (max-width: 320px) {
        .content-container {
            margin: -50px auto 0;
        }
    }
</style>



// WEBPACK FOOTER //
// SectionWhyUs.vue?c5bfeaa8